import React from "react";
import { Link } from "react-router-dom";
// import faqData from "../../api/faqdata";
import { formatPage } from "../../utils/formatPage";
import { useFaqData } from "../../api/useFaqData";
import FaqContact from "../../components/FaqContact/FaqContact";
import { useTranslation } from "react-i18next";
// Rastgele karıştırma fonksiyonu (Fisher-Yates Shuffle)
const shuffleArray = (array) => {
  const copy = [...array];
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy;
};

const FaqRightMenu = () => {
  const { t } = useTranslation();
  const faqData = useFaqData();
  // Tüm soruları kategori ile birlikte topla
  const allFaqs = faqData.flatMap((category) =>
    category.faqs.map((faq) => ({
      ...faq,
      category: category.text,
    }))
  );

  // Soruları rastgele sırala
  const shuffledFaqs = shuffleArray(allFaqs).slice(0, 4); // ilk 3 rastgele soru

  return (
    <>
      <div className="bg-white w-100 mb-3">
        <h5 className="fw-light p-4 pb-1 text-start">{t("HelpfulTopics")}</h5>
        <hr className="mb-0" />

        <div className="row p-3">
          {shuffledFaqs.map((faq, index) => (
            <Link
              key={index}
              to={`/faq/${formatPage(faq.category)}/${faq.id}`}
              className={`text-dark fw-light d-block mb-2 pb-3 ${
                index !== shuffledFaqs.length - 1 ? "border-bottom" : ""
              }`}
              style={{ padding: 10 }}
            >
              {faq.question}
            </Link>
          ))}
        </div>
      </div>

      <div className="bg-white w-100 p-4 mb-3">
        <h5 className="fw-light">{t("FREQUENTQUESTIONS")}</h5>
        <p className="fs-11 fw-light mt-3">{t("FREQUENTQUESTIONSDesc")}</p>
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-8 col-12">
            <a
              href="/faq"
              className="btn bgcolorfooterbottom   fs-14 p-3 w-100 mt-2"
            >
              {t("FREQUENTQUESTIONSBtn")}
            </a>
          </div>
        </div>
      </div>
      <FaqContact />
    </>
  );
};

export default FaqRightMenu;
